<template>
    <div>
        <div id="accordion" v-if="contractDetails.contractMilestones.length >0">
            <div class="card najiz-card-panel mb-3">
                <div class="card-header najiz-panel-header" id="milestones-heading">
                    <a class="text-dark" data-toggle="collapse" href="#milestones-collapse" role="button" aria-expanded="false"
                       aria-controls="milestones-collapse">
                        <h4 class="mb-0 py-3">
                            <i class="fal fa-angle-up rotate-icon fa-lg ml-5"></i>
                            <b>
                                3- بيان سداد الدفعات وتواريخ الاستحقاق
                            </b>
                        </h4>
                    </a>
                </div>

                <div id="milestones-collapse" class="collapse show" aria-labelledby="milestones-heading" data-parent="#accordion">
                    <div class="card-body">

                        <table class="table table-striped">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" scope="col">رقم الدفعة</th>
                                    <th class="text-center" scope="col">وصف الدفعة</th>
                                    <th class="text-center" scope="col">
                                        قيمة الاستحقاق (ريال) (شاملة ضريبة القيمة المضافة)
                                    </th>
                                    <th class="text-center" scope="col">تاريخ الاستحقاق</th>
                                    <th class="text-center" scope="col"> تاريخ نهاية مهلة السداد</th>
                                    <th class="text-center" scope="col">حالة الدفعة</th>
                                    <th class="text-center" scope="col">رقم الفاتورة</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, masterIndex) in contractDetails.contractMilestones" :key="masterIndex">
                                    <td class="text-center">{{ item.batchNumber }}</td>
                                    <td class="text-center"> {{ item.batchDescription }}</td>
                                    <td class="text-center">{{ item.amount }}</td>
                                    <td class="text-center">{{ item.dueDate }}</td>
                                    <td class="text-center"> {{ item.dueDateForExecution !== '0001/01/01' ? item.dueDateForExecution : ' - ' }}</td>
                                    <td class="text-center">{{ item.batchStatusName }}</td>
                                    <td class="text-center">{{ item.invoiceNumber }}</td>
                                </tr>

                            </tbody>
                        </table>




                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Vue, Prop } from 'vue-property-decorator';

    import { ContractDetails } from '@/models/contract.model';

    @Component
    export default class ContractMilestonesComponent extends Vue {
        @Prop({ required: true }) contractDetails!: ContractDetails;


    }
</script>
